import {Component, OnInit, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import {LocalService} from '../../../_services/local.service';
import {AnagraficaBase} from '../../../_models/AnagraficaBase';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {SaveMessage} from '../../../_helpers/save-message';
import {Subscription} from 'rxjs';
import {Organizzazione} from '../../../_models/Organizzazione';

@Component({
    selector: 'app-select-fornitori',
    templateUrl: './select-fornitori.component.html',
    styleUrls: ['./select-fornitori.component.scss'],
    standalone: false
})
export class SelectFornitoriComponent  implements OnInit, OnDestroy {
  @Input() selectedFornitoreId = 0;
  @Input() gruppoDoc = '';
  @Input() fornitore: AnagraficaBase;
  @Output() fornitoreChange = new EventEmitter<AnagraficaBase>();
  @Input() groupDocOriginale = 0;
  fornitori: AnagraficaBase[] = [];
  isOpen = true;
  search = '';
  subscription: Subscription;
  loading = false;
  constructor(
    private organizzazioneService: OrganizzazioniService,
    private localService: LocalService,
    private saveMessage: SaveMessage) {
    this.subscription = this.organizzazioneService.currentOrganizzazioneSubject
      .subscribe((_org: Organizzazione) => this.getFornitoriOrdiniAperti());
    this.subscription.add(this.localService.searchText.subscribe(text => {
      this.search = text;
      this.getFornitoriOrdiniAperti();
    }));
  }

  ngOnInit() {
    this.getFornitoriOrdiniAperti();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getFornitoriOrdiniAperti = () => {
    if (!this.gruppoDoc){
      return false;
    } 
    this.loading = true;
    this.fornitori = [];
    this.localService
      .getFornitoriOrdiniApertiAsync(this.organizzazioneService.organizzazioneId, this.gruppoDoc, this.groupDocOriginale, this.search)
      .then((_fornitori: SearchResult<AnagraficaBase>) => {
        if (_fornitori.totalCount > 0) {
          this.isOpen = true;
          this.fornitori = _fornitori.result;
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei fornitori."))
      .finally(() => this.loading = false);
  };

  selectFornitore = (fornitore: AnagraficaBase) => {
    if (!this.isOpen) {
      this.isOpen = true;
      return false;
    }
    this.isOpen = false;
    this.selectedFornitoreId = fornitore.id;
    this.fornitore = fornitore;
    this.fornitoreChange.emit(fornitore);
  };

  openList = () => this.isOpen = !this.isOpen;
}
